import type { MarkType } from '@tiptap/pm/model'
import { Plugin, PluginKey } from '@tiptap/pm/state'

type MouseoverHandlerOptions = {
  type: MarkType,
  nodeName: string,
  onMouseover?: (suggestionId: string, event: MouseEvent) => void,
}

export function mouseoverHandler(options: MouseoverHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey('handleMouseoverSuggestion'),
    props: {
      handleDOMEvents: {
        pointerover: (view, event) => {
          const element = event.target as HTMLElement

          if (element.nodeName !== options.nodeName) {
            return false
          }

          const suggestionId = element.getAttribute('data-suggestion-id')

          if (suggestionId) options.onMouseover?.(suggestionId, event)

          return false
        },
      },
    },
  })
}
